<template>
    <div>
        <van-nav-bar style="" title="待办" fixed/>
        <van-row class="grid" style="margin: 46px 0 0 0">
            <div @click="routerUrl('/home/mortgage-list')">
                <van-col span="12">
                    <span v-if="mortgageCount > 0" class="badge">{{mortgageCount}}</span>
                    <van-row>
                        <img width="28px" height="28px" src="../../assets/home/ic_house.png"/>
                    </van-row>
                    <van-row>房抵贷</van-row>
                </van-col>
            </div>
            <div @click="routerUrl('/home/redemption-list')">
                <van-col span="12">
                    <span v-if="foreclosureCount > 0" class="badge">{{foreclosureCount}}</span>
                    <van-row>
                        <img width="28px" height="28px" src="../../assets/home/ic_redemption.png"/>
                    </van-row>
                    <van-row>赎楼贷</van-row>
                </van-col>
            </div>
        </van-row>
        <van-row class="grid">
            <div @click="routerUrl('/home/enterprise-list')">
                <van-col span="12">
                    <span v-if="enterpriseCreditCount > 0" class="badge">{{enterpriseCreditCount}}</span>
                    <van-row>
                        <img width="28px" height="28px" src="../../assets/home/ic_redemption.png"/>
                    </van-row>
                    <van-row>企业贷</van-row>
                </van-col>
            </div>
            <div @click="routerUrl('/home/tail-list')">
                <van-col span="12">
                    <span v-if="tailCount > 0" class="badge">{{tailCount}}</span>
                    <van-row>
                        <img width="28px" height="28px" src="../../assets/home/ic_house.png"/>
                    </van-row>
                    <van-row>尾期贷</van-row>
                </van-col>
            </div>
        </van-row>
    </div>
</template>

<script>

    import { getTodos } from '@/api/loanInfo'
    import { eventBus } from '../../vue/utils/eventBus'

    export default {
        name: 'home_index',
        components: {},
        data: function () {
            return {
                pageNo: 1,
                pageSize: 10,
                list: [],
                error: false,
                loading: false,
                finished: false,
                mortgageCount: 0,
                foreclosureCount: 0,
                tailCount:0,
                enterpriseCreditCount: 0,
            }
        },
        mounted() {
            //eventBus.$emit('showTabBar',true)
            this.getToDoList()
        },
        methods: {
            routerUrl(url) {
                this.$router.push({path: url})
            },
            toInfo(index) {
                this.$router.push({path: '/loan-list/' + index})
            },
            getToDoList() {
                getTodos().then(res => {
                    if (res.success) {
                        this.mortgageCount = res.data[0].mortgageCount
                        this.foreclosureCount = res.data[0].foreclosureCount
                        this.enterpriseCreditCount = res.data[0].enterpriseCreditCount
                        this.tailCount=res.data[0].tailCount
                        let count = parseInt(this.mortgageCount) + parseInt(this.foreclosureCount) + parseInt(this.enterpriseCreditCount)+parseInt(this.tailCount)
                        //底部标签栏显示数量
                        eventBus.$emit('tabbarInfo',count)
                    }
                })
            }
        }
    }
</script>

<style>
    .grid {
        font-size: 14px;
        text-align: center;
        padding: 20px 10px;
    }

    .grid img {
        width: 28px;
        height: 28px;
    }

    .center {
        text-align: center;
    }

    .item {
        font-size: 14px;
        width: 25%;
        float: left;
    }
    .van-info{
        padding: 0 !important;
    }

    .badge {
        background-color: #f44;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        margin: -5px 0 0 15px;
        border-radius: 16px;
        color: #fff;
        padding: 0 3px;
        border: 1px solid #fff;
        font-size: 12px;
        position: absolute;
        font-weight: 500;
        line-height: 14px;
        min-width: 16px;
    }
</style>
